import React from 'react';

/*
 RoleBadge
 - props: role ('admin' | 'manager' | 'user')
 - renders small circular badge with role-specific icon & color
*/

const ICON_SIZE = 14;

const icons = {
  admin: (
    <svg width={ICON_SIZE} height={ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3l7.53 4.35v8.3L12 20.99 4.47 15.65v-8.3L12 3z" />
      <path d="M12 8v4" />
      <circle cx="12" cy="15" r="1" />
    </svg>
  ),
  manager: (
    <svg width={ICON_SIZE} height={ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 8l9-5 9 5-9 5-9-5z" />
      <path d="M3 14l9 5 9-5" />
      <path d="M3 11.98l9 5 9-5" />
    </svg>
  ),
  user: (
    <svg width={ICON_SIZE} height={ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c1.7-3.2 4.5-5 8-5s6.3 1.8 8 5" />
    </svg>
  ),
};

const roleLabels = {
  admin: 'Admin',
  manager: 'Manager',
  user: 'User',
};

const RoleBadge = ({ role }) => {
  if (!role) return null;
  const icon = icons[role] || icons.user;
  const label = roleLabels[role] || role;
  return (
    <span className={`role-badge role-${role}`} title={label} aria-label={label}>
      {icon}
    </span>
  );
};

export default RoleBadge;
